import LightTextLogo from "@Light/assets/LightTextLogo.tsx";
import { useScaffold } from "@Light/scaffold";
import {
  DEFAULT_UTILITY_BEHAVIOR,
  type UtilityBehavior,
} from "@Light/utils/utility";
import clsx from "clsx";
import { useId } from "react";
import { Tooltip } from "react-tooltip";

export type TrustProps = {
  /** Utility behavior configuration to use. Defaults to `DEFAULT_UTILITY_BEHAVIOR`. */
  utility?: Pick<UtilityBehavior, "trustDisplay">;
  size?: "sm" | "md";
};

export const Trust = ({
  utility = DEFAULT_UTILITY_BEHAVIOR,
  size = "sm",
}: TrustProps) => {
  const scaffold = useScaffold();
  const tooltipId = useId();
  const { icon: Icon, text, license } = utility.trustDisplay;
  const isMedium = size === "md";
  const textSize = isMedium ? "text-sm" : "text-xs";
  const iconSize = isMedium ? 20 : 16;

  return (
    <div className={clsx("flex flex-col text-center", isMedium && "gap-xs")}>
      <div
        data-tooltip-id={tooltipId}
        className={clsx("font-medium text-tertiary", textSize)}
      >
        Powered by
        {/* Sized in em to keep its 12px-text proportions at any text size, and
            offset by its descender so its baseline matches the text's. */}
        <LightTextLogo className="ml-1 inline h-[1.1935em] w-auto align-[-0.2689em] text-black" />
      </div>
      <div
        className={clsx(
          "flex flex-row items-center justify-center gap-1.5 font-normal text-tertiary",
          textSize,
        )}
      >
        <Icon width={iconSize} height={iconSize} />
        {text}
      </div>
      <Tooltip id={tooltipId} place="top">
        <div className="text-xs">
          {scaffold.page.companyName} partners with Light
          {license ? ` (${license})` : ""}, a licensed and experienced energy
          provider, to provide this bespoke electricity plan.
        </div>
      </Tooltip>
    </div>
  );
};
